import { AxiosResponse } from "axios";
import { IAuthService } from "../interfaces/AuthService";
import { IRefreshToken } from "../interfaces/IRefreshToken";
import { IToken } from "../interfaces/IToken";
import { hdaAuthApi, hdaAuthorizedAuthApi } from "@/modules/hda/api/clients";
import { mapAxiosData, asVoidResponse } from "@/modules/hda/mappers/axiosMap";
import type { TokenResponse } from "@/api-clients/hda/openapi/auth/api";

function mapTokenResponse(dto: TokenResponse): IToken {
  return {
    accessToken: dto.accessToken ?? "",
    refreshToken: dto.refreshToken ?? "",
    idToken: dto.idToken ?? "",
    tokenType: "Bearer",
    expiresIn: dto.expiresIn ?? 0,
  };
}

function mapRefreshTokenResponse(dto: TokenResponse): IRefreshToken {
  return {
    accessToken: dto.accessToken ?? "",
    refreshToken: dto.refreshToken ?? "",
    tokenType: "Bearer",
    expiresIn: dto.expiresIn ?? 0,
  };
}

export class AuthService implements IAuthService {
  getToken(code: string): Promise<AxiosResponse<IToken>> {
    return mapAxiosData(hdaAuthApi.exchangeToken({ code }), mapTokenResponse);
  }

  refreshToken(refreshToken: string): Promise<AxiosResponse<IRefreshToken>> {
    return mapAxiosData(hdaAuthApi.refreshToken({ refresh_token: refreshToken } as any), mapRefreshTokenResponse);
  }

  revokeSession(piSri: string): Promise<AxiosResponse<{ id: string }>> {
    return asVoidResponse(hdaAuthorizedAuthApi.revokeSession({ piSri })).then((response) => ({
      ...response,
      data: { id: piSri },
    }));
  }
}
